<mat-form-field floatLabel="always" class="multi-picklist-dropdown">
  <mat-label>{{ field.label }}</mat-label>
  <mat-select placeholder="{{ 'salesforceMultiPicklistField.placeholder' | translate }}"
              [(ngModel)]="selectedValue"
              (ngModelChange)="onSelectionChange()"
              multiple>
    <mat-option *ngFor="let item of field.picklistValues" [value]="item.value">{{ item.value }}</mat-option>
  </mat-select>
</mat-form-field>

<mat-error class="error-message mat-error-message" *ngIf="!isValid">
  {{ "salesforceMultiPicklistField.required" | translate: { label: field.label } }}
</mat-error>
<mat-error class="error-message mat-error-message" *ngIf="errorText">
  {{ errorText }}
</mat-error>
